import React from "react";
import { Resizable, ResizeCallbackData } from "react-resizable";

interface ResizableTitleProps {
  onResize: (e: React.SyntheticEvent, data: ResizeCallbackData) => any;
  width: number;
  [key: string]: any; // To allow passing other th props
}

/**
 * A table header cell component that supports horizontal resizing.
 */
const ResizableTableHeader = (props: ResizableTitleProps) => {
  const { onResize, width, ...restProps } = props;

  // Render a normal th if width is not provided (e.g., for selection column)
  if (!width) {
    return <th {...restProps} />;
  }

  return (
    <Resizable
      width={width}
      height={0} // We only resize width
      handle={<span className="react-resizable-handle" />} // Custom handle defined via Tailwind/CSS
      onResize={onResize}
      draggableOpts={{ enableUserSelectHack: false }} // Prevent text selection issues during drag
    >
      <th {...restProps} />
    </Resizable>
  );
};

export default ResizableTableHeader;
